import React from 'react'

export const Logo2 = ({ height = '30px', width = '30px', fill = '#555' }) => (
    <svg
        enableBackground="new 0 0 24 24"
        id="Layer_1"
        version="1.0"
        height={height}
        width={width}
        viewBox="0 0 24 24"
        fill={fill}
        space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
    >
        <polygon points="12,3 1,9 12,15 23,9 " />
        <polygon points="19,12.8 12,17 5,12.8 5,17.2 12,21 19,17.2 " />
        <rect height="8" width="2" x="21" y="9" />
    </svg>
)

export const Logo = ({ height = '50px', width = '120px', fill = '#555' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        height={height}
        width={width}
        viewBox="0 0 604 254"
        xmlns="http://www.w3.org/1999/xlink"
        xmlns="http://svgjs.com/svgjs"
        overflow="visible"
    >
        <g className="signage-logo" opacity="1">
            <defs id="SvgjsDefs1002">
                <linearGradient
                    id="SvgjsLinearGradienthNkPsybOO"
                    gradientUnits="userSpaceOnUse"
                    x1="42.525"
                    y1="181.465"
                    x2="266.51499999999993"
                    y2="-42.525000000000006"
                >
                    <stop
                        id="SvgjsStop1010"
                        stopColor="#fc3421"
                        offset="0.05"
                    ></stop>
                    <stop
                        id="SvgjsStop1011"
                        stopColor="#9c0f02"
                        offset="0.95"
                    ></stop>
                </linearGradient>
            </defs>
            <g
                id="SvgjsG1008"
                transform="scale(1.8405384416256796)"
                opacity="1"
            >
                <g
                    id="SvgjsG1012"
                    className="hyIBQ1OlD"
                    light-content="false"
                    fill="url(#SvgjsLinearGradienthNkPsybOO)"
                >
                    <path d="M0 0 h 309.03999999999996 v 138.94 h -309.03999999999996 Z"></path>
                </g>
                <g
                    id="SvgjsG1013"
                    className="text"
                    transform="translate(156.44000244140625, 61.880001068115234) scale(1)"
                    light-content="true"
                    fill="#ffffff"
                >
                    <path d="M-136.44 -3.6C-134.28 -2.2 -131.85 -1.1 -129.15 -0.3C-126.45 0.5 -123.86 0.9 -121.38 0.9C-116.34 0.9 -112.47 -0.28 -109.77 -2.64C-107.07 -5 -105.72 -8.08 -105.72 -11.88C-105.72 -14.44 -106.51 -16.73 -108.09 -18.75C-109.67 -20.77 -111.9 -22.4 -114.78 -23.64L-121.98 -26.64C-124.46 -27.72 -125.7 -29.06 -125.7 -30.66C-125.7 -31.66 -125.26 -32.55 -124.38 -33.33C-123.5 -34.11 -122.24 -34.5 -120.6 -34.5C-117.48 -34.5 -113.88 -33.52 -109.8 -31.56C-107.92 -33.4 -106.88 -35.7 -106.68 -38.46C-111.08 -40.74 -115.53 -41.88 -120.03 -41.88C-124.53 -41.88 -128.16 -40.72 -130.92 -38.4C-133.68 -36.08 -135.06 -33.1 -135.06 -29.46C-135.06 -24.62 -132.22 -20.96 -126.54 -18.48L-119.46 -15.48C-116.78 -14.28 -115.44 -12.68 -115.44 -10.68C-115.44 -9.52 -115.89 -8.53 -116.79 -7.71C-117.69 -6.89 -119 -6.48 -120.72 -6.48C-124.44 -6.48 -128.48 -7.8 -132.84 -10.44C-133.76 -9.68 -134.56 -8.67 -135.24 -7.41C-135.92 -6.15 -136.32 -4.88 -136.44 -3.6Z M-83.64 -8.76L-75.12 -8.76C-73.96 -8.76 -73.1 -8.78 -72.54 -8.82L-71.28 -4.44C-70.76 -2.52 -70.1 -1.21 -69.3 -0.51C-68.5 0.19 -67.18 0.54 -65.34 0.54C-63.5 0.54 -61.92 0.16 -60.6 -0.6L-73.56 -40.92C-74.92 -41.2 -76.66 -41.34 -78.78 -41.34C-80.9 -41.34 -82.68 -41.22 -84.12 -40.98L-97.44 -0.72L-97.08 -0.24C-96 0.2 -94.58 0.42 -92.82 0.42C-91.06 0.42 -89.72 0.3 -88.8 0.06L-86.16 -8.82C-85.6 -8.78 -84.76 -8.76 -83.64 -8.76ZM-84.06 -15.96L-82.38 -21.48C-80.82 -26.88 -79.86 -30.56 -79.5 -32.52L-79.2 -32.52L-74.64 -15.96C-74.92 -15.96 -75.32 -15.97 -75.84 -15.99C-76.36 -16.01 -76.72 -16.02 -76.92 -16.02L-81.54 -16.02Z M-20.28 -28.38C-20.28 -32.66 -21.6 -35.89 -24.24 -38.07C-26.88 -40.25 -30.38 -41.34 -34.74 -41.34C-37.46 -41.34 -42.18 -41.26 -48.9 -41.1L-49.32 -40.68L-49.32 0C-48.16 0.24 -46.66 0.36 -44.82 0.36C-42.98 0.36 -41.46 0.24 -40.26 0L-40.26 -15.24L-37.44 -15.24C-35.92 -15.24 -34.77 -14.9 -33.99 -14.22C-33.21 -13.54 -32.62 -12.58 -32.22 -11.34L-29.94 -4.8C-29.26 -2.84 -28.54 -1.46 -27.78 -0.66C-27.02 0.14 -25.94 0.54 -24.54 0.54C-23.14 0.54 -21.88 0.28 -20.76 -0.24C-19.64 -0.76 -18.78 -1.42 -18.18 -2.22C-19.46 -3.22 -20.44 -4.68 -21.12 -6.6L-23.04 -11.94C-24.04 -14.86 -25.56 -16.68 -27.6 -17.4C-25.64 -18.12 -23.93 -19.46 -22.47 -21.42C-21.01 -23.38 -20.28 -25.7 -20.28 -28.38ZM-40.26 -34.44C-39.06 -34.4 -37.46 -34.38 -35.46 -34.38C-31.58 -34.38 -29.64 -32.38 -29.64 -28.38C-29.64 -24.38 -31.58 -22.38 -35.46 -22.38C-36.02 -22.38 -37.62 -22.34 -40.26 -22.26Z M25.32 -2.28L24.66 -3C24.42 -3.2 24.21 -3.45 24.03 -3.75C23.85 -4.05 23.7 -4.28 23.58 -4.44C23.46 -4.6 23.33 -4.87 23.19 -5.25C23.05 -5.63 22.95 -5.88 22.89 -6C22.83 -6.12 22.72 -6.42 22.56 -6.9C22.4 -7.38 22.3 -7.66 22.26 -7.74L19.74 -15.36C19.06 -17.28 18.23 -18.8 17.25 -19.92C16.27 -21.04 14.86 -21.8 13.02 -22.2C14.26 -23.24 15.34 -24.64 16.26 -26.4L23.76 -40.38L23.28 -41.04C21.68 -41.2 20.05 -41.28 18.39 -41.28C16.73 -41.28 15.57 -41.04 14.91 -40.56C14.25 -40.08 13.62 -39.26 13.02 -38.1L7.08 -27C6.64 -26.2 6.26 -25.67 5.94 -25.41C5.62 -25.15 5.1 -25.02 4.38 -25.02L2.64 -24.96L2.64 -40.98C1.44 -41.22 -0.1 -41.34 -1.98 -41.34C-3.86 -41.34 -5.38 -41.22 -6.54 -40.98L-6.54 0C-5.38 0.24 -3.86 0.36 -1.98 0.36C-0.1 0.36 1.44 0.24 2.64 0L2.64 -17.28C4.08 -17.36 5.02 -17.4 5.46 -17.4C6.94 -17.4 8.12 -16.99 9 -16.17C9.88 -15.35 10.64 -13.96 11.28 -12L13.68 -4.74C14.24 -2.86 14.91 -1.52 15.69 -0.72C16.47 0.08 17.66 0.48 19.26 0.48C22.06 0.48 24.08 -0.44 25.32 -2.28Z M46.2 -8.76L54.72 -8.76C55.88 -8.76 56.74 -8.78 57.3 -8.82L58.56 -4.44C59.08 -2.52 59.74 -1.21 60.54 -0.51C61.34 0.19 62.66 0.54 64.5 0.54C66.34 0.54 67.92 0.16 69.24 -0.6L56.28 -40.92C54.92 -41.2 53.18 -41.34 51.06 -41.34C48.94 -41.34 47.16 -41.22 45.72 -40.98L32.4 -0.72L32.76 -0.24C33.84 0.2 35.26 0.42 37.02 0.42C38.78 0.42 40.12 0.3 41.04 0.06L43.68 -8.82C44.24 -8.78 45.08 -8.76 46.2 -8.76ZM45.78 -15.96L47.46 -21.48C49.02 -26.88 49.98 -30.56 50.34 -32.52L50.64 -32.52L55.2 -15.96C54.92 -15.96 54.52 -15.97 54 -15.99C53.48 -16.01 53.12 -16.02 52.92 -16.02L48.3 -16.02Z M109.56 -28.38C109.56 -32.66 108.24 -35.89 105.6 -38.07C102.96 -40.25 99.46 -41.34 95.1 -41.34C92.38 -41.34 87.66 -41.26 80.94 -41.1L80.52 -40.68L80.52 0C81.68 0.24 83.18 0.36 85.02 0.36C86.86 0.36 88.38 0.24 89.58 0L89.58 -15.24L92.4 -15.24C93.92 -15.24 95.07 -14.9 95.85 -14.22C96.63 -13.54 97.22 -12.58 97.62 -11.34L99.9 -4.8C100.58 -2.84 101.3 -1.46 102.06 -0.66C102.82 0.14 103.9 0.54 105.3 0.54C106.7 0.54 107.96 0.28 109.08 -0.24C110.2 -0.76 111.06 -1.42 111.66 -2.22C110.38 -3.22 109.4 -4.68 108.72 -6.6L106.8 -11.94C105.8 -14.86 104.28 -16.68 102.24 -17.4C104.2 -18.12 105.91 -19.46 107.37 -21.42C108.83 -23.38 109.56 -25.7 109.56 -28.38ZM89.58 -34.44C90.78 -34.4 92.38 -34.38 94.38 -34.38C98.26 -34.38 100.2 -32.38 100.2 -28.38C100.2 -24.38 98.26 -22.38 94.38 -22.38C93.82 -22.38 92.22 -22.34 89.58 -22.26Z M123.42 0C124.62 0.24 126.15 0.36 128.01 0.36C129.87 0.36 131.4 0.24 132.6 0L132.6 -40.98C131.4 -41.22 129.87 -41.34 128.01 -41.34C126.15 -41.34 124.62 -41.22 123.42 -40.98Z"></path>
                </g>
                <g
                    id="SvgjsG1014"
                    className="text"
                    transform="translate(154.55000305175778, 118.34000045776367) scale(1)"
                    light-content="true"
                    fill="#ffffff"
                >
                    <path d="M-122.49 -11.58L-122.49 -16.86L-109.05 -16.86C-108.69 -17.9 -108.51 -19.17 -108.51 -20.67C-108.51 -22.17 -108.69 -23.4 -109.05 -24.36L-118.47 -24.36C-120.11 -24.36 -121.45 -24.34 -122.49 -24.3L-122.49 -29.04L-122.55 -33.3L-105.93 -33.3C-105.45 -34.7 -105.21 -36.1 -105.21 -37.5C-105.21 -38.9 -105.31 -40.06 -105.51 -40.98L-131.13 -40.98L-131.55 -40.56L-131.55 -5.22C-131.55 -3.54 -131.08 -2.22 -130.14 -1.26C-129.2 -0.3 -127.91 0.18 -126.27 0.18L-110.07 0.18C-106.71 0.18 -104.75 -1.3 -104.19 -4.26C-104.07 -4.98 -104.01 -6.06 -104.01 -7.5L-118.17 -7.5C-119.33 -7.5 -120.79 -7.46 -122.55 -7.38L-122.55 -7.44Z M-69.81 -40.98L-76.89 -28.98L-82.47 -37.98C-83.31 -39.3 -84.16 -40.22 -85.02 -40.74C-85.88 -41.26 -87.16 -41.52 -88.86 -41.52C-90.56 -41.52 -92.35 -40.86 -94.23 -39.54L-82.83 -21.18L-95.25 -0.96L-95.01 -0.42C-93.45 0.1 -91.85 0.36 -90.21 0.36C-88.57 0.36 -87.27 0.24 -86.31 0L-78.15 -13.68L-71.55 -3.06C-70.71 -1.7 -69.85 -0.76 -68.97 -0.24C-68.09 0.28 -66.8 0.54 -65.1 0.54C-63.4 0.54 -61.61 -0.12 -59.73 -1.44L-72.21 -21.48L-60.93 -40.08L-61.17 -40.56C-62.57 -41.08 -64.12 -41.34 -65.82 -41.34C-67.52 -41.34 -68.85 -41.22 -69.81 -40.98Z M-38.73 -8.76L-30.21 -8.76C-29.05 -8.76 -28.19 -8.78 -27.63 -8.82L-26.37 -4.44C-25.85 -2.52 -25.19 -1.21 -24.39 -0.51C-23.59 0.19 -22.27 0.54 -20.43 0.54C-18.59 0.54 -17.01 0.16 -15.69 -0.6L-28.65 -40.92C-30.01 -41.2 -31.75 -41.34 -33.87 -41.34C-35.99 -41.34 -37.77 -41.22 -39.21 -40.98L-52.53 -0.72L-52.17 -0.24C-51.09 0.2 -49.67 0.42 -47.91 0.42C-46.15 0.42 -44.81 0.3 -43.89 0.06L-41.25 -8.82C-40.69 -8.78 -39.85 -8.76 -38.73 -8.76ZM-39.15 -15.96L-37.47 -21.48C-35.91 -26.88 -34.95 -30.56 -34.59 -32.52L-34.29 -32.52L-29.73 -15.96C-30.01 -15.96 -30.41 -15.97 -30.93 -15.99C-31.45 -16.01 -31.81 -16.02 -32.01 -16.02L-36.63 -16.02Z M-5.67 -0.12C-4.51 0.2 -3.05 0.36 -1.29 0.36C0.47 0.36 1.91 0.26 3.03 0.06L3.99 -17.34C4.23 -21.54 4.39 -26.08 4.47 -30.96L4.89 -30.96L11.07 -6.06C12.23 -5.86 13.82 -5.76 15.84 -5.76C17.86 -5.76 19.41 -5.86 20.49 -6.06L26.73 -30.96L27.15 -30.96C27.15 -27.4 27.31 -22.86 27.63 -17.34L28.59 0.06C29.71 0.26 31.15 0.36 32.91 0.36C34.67 0.36 36.11 0.2 37.23 -0.12L34.05 -40.92C32.57 -41.2 30.59 -41.34 28.11 -41.34C25.63 -41.34 23.63 -41.2 22.11 -40.92L18.27 -25.68C17.19 -21.24 16.43 -17.66 15.99 -14.94L15.63 -14.94C15.19 -17.66 14.43 -21.24 13.35 -25.68L9.51 -40.92C8.03 -41.2 6.04 -41.34 3.54 -41.34C1.04 -41.34 -0.97 -41.2 -2.49 -40.92Z M49.95 -3.96C49.95 -2.52 50.19 -1.34 50.67 -0.42C51.75 0.26 53.27 0.6 55.23 0.6C57.19 0.6 58.71 0.26 59.79 -0.42C60.23 -1.34 60.45 -2.52 60.45 -3.96C60.45 -5.4 60.23 -6.58 59.79 -7.5C58.55 -8.22 57.03 -8.58 55.23 -8.58C53.43 -8.58 51.91 -8.22 50.67 -7.5C50.19 -6.58 49.95 -5.4 49.95 -3.96Z M74.49 0C75.69 0.24 77.22 0.36 79.08 0.36C80.94 0.36 82.47 0.24 83.67 0L83.67 -40.98C82.47 -41.22 80.94 -41.34 79.08 -41.34C77.22 -41.34 75.69 -41.22 74.49 -40.98Z M131.07 -41.34L128.07 -41.34C126.27 -41.34 124.97 -40.92 124.17 -40.08C123.37 -39.24 122.97 -37.82 122.97 -35.82L122.97 -27.42C122.97 -21.38 123.21 -15.6 123.69 -10.08L123.45 -10.02L119.67 -19.08L109.95 -40.98C108.35 -41.22 106.52 -41.34 104.46 -41.34C102.4 -41.34 100.65 -41.16 99.21 -40.8L99.21 0C100.37 0.24 101.78 0.36 103.44 0.36C105.1 0.36 106.53 0.24 107.73 0L107.73 -12.9C107.73 -18.86 107.49 -24.68 107.01 -30.36L107.25 -30.42C107.85 -28.78 108.99 -25.96 110.67 -21.96L120.63 0C122.23 0.24 124.06 0.36 126.12 0.36C128.18 0.36 129.97 0.18 131.49 -0.18L131.49 -40.98Z"></path>
                </g>
            </g>
        </g>
    </svg>
)

export const Logo1 = ({ height = '60px', width = '100px', fill = '#555' }) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        width={width}
        viewBox="0 0 1200.000000 1200.000000"
        preserveAspectRatio="xMidYMid meet"
    >
        <g
            transform="translate(0.000000,1200.000000) scale(0.100000,-0.100000)"
            fill="#e91e63"
            stroke="none"
        >
            <path
                d="M5600 10162 c-256 -142 -904 -501 -1440 -799 -1064 -589 -1829 -1013
    -2012 -1114 l-118 -64 3 -564 2 -564 140 -78 c77 -42 302 -167 500 -277 l360
-199 3 -759 2 -759 298 -164 c163 -91 390 -216 503 -278 l207 -114 248 137
c137 76 364 201 504 279 l255 140 3 760 2 760 505 279 c340 187 505 284 506
295 0 12 2 11 8 -4 6 -13 151 -99 397 -235 214 -118 439 -242 499 -276 l110
-61 3 -759 2 -759 298 -164 c163 -91 390 -216 503 -278 l207 -114 248 137
c137 76 364 201 504 279 l255 140 3 760 2 760 505 279 505 278 0 562 -1 561
-732 404 c-403 223 -1155 639 -1672 926 -1499 832 -1632 905 -1641 905 -5 -1
-218 -117 -474 -258z m480 -2002 c0 -11 -2 -20 -4 -20 -2 0 -6 9 -9 20 -3 11
-1 20 4 20 5 0 9 -9 9 -20z m-3 -52 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0
-40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6
6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3
-8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1
11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3
-3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6
-5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2
17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0
-40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m0 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"
            />
            <path
                d="M3260 3185 l0 -565 100 0 100 0 0 123 0 123 40 39 c27 26 43 36 48
28 4 -6 50 -79 102 -161 l95 -151 118 -1 118 0 -156 230 -156 231 118 135 c65
75 128 149 141 165 l23 29 -119 0 -120 0 -124 -146 -123 -145 -3 315 -2 316
-100 0 -100 0 0 -565z"
            />
            <path
                d="M5440 3693 c-61 -57 -37 -149 45 -172 111 -30 194 91 116 170 -25 24
    -37 29 -80 29 -41 0 -56 -5 -81 -27z"
            />
            <path
                d="M9980 3693 c-61 -57 -37 -149 45 -172 111 -30 194 91 116 170 -25 24
    -37 29 -80 29 -41 0 -56 -5 -81 -27z"
            />
            <path
                d="M1297 3689 c-74 -8 -172 -49 -224 -93 -80 -67 -106 -201 -59 -301 43
    -92 134 -154 330 -222 126 -44 147 -55 180 -93 56 -68 21 -167 -67 -191 -58
-16 -168 -6 -209 18 -42 24 -78 77 -78 114 l0 29 -105 0 -105 0 0 -37 c1 -86
79 -192 180 -242 78 -40 151 -55 255 -53 230 3 365 109 365 286 0 164 -96 258
-345 341 -120 40 -164 63 -195 102 -38 49 -21 119 39 156 47 29 168 31 219 4
37 -20 72 -71 72 -104 0 -22 3 -23 105 -23 l105 0 0 29 c0 40 -18 89 -51 137
-75 110 -231 164 -412 143z"
            />
            <path
                d="M5820 3155 l0 -535 355 0 355 0 0 85 0 85 -250 0 -250 0 0 150 0 150
210 0 210 0 0 85 0 85 -210 0 -210 0 0 130 0 130 245 0 245 0 0 85 0 85 -350
0 -350 0 0 -535z"
            />
            <path
                d="M2160 3420 c-112 -14 -209 -74 -246 -154 -40 -86 -40 -86 79 -86
l103 0 9 33 c22 72 147 89 200 26 19 -23 25 -42 25 -78 l0 -48 -106 -7 c-239
-16 -346 -96 -347 -256 0 -138 104 -232 257 -232 78 0 124 15 173 56 34 29 37
27 48 -21 l7 -33 104 0 c105 0 105 0 98 23 -20 62 -24 110 -24 318 0 274 -8
310 -80 380 -69 68 -172 95 -300 79z m170 -509 l0 -80 -36 -27 c-27 -21 -50
-29 -93 -32 -50 -4 -61 -1 -89 23 -43 36 -45 98 -6 144 31 37 68 49 157 50
l67 1 0 -79z"
            />
            <path
                d="M3045 3420 c-44 -10 -69 -25 -103 -65 -17 -19 -34 -35 -37 -35 -3 0
    -5 20 -5 45 l0 45 -95 0 -95 0 0 -395 0 -395 100 0 100 0 0 263 c0 289 0 291
63 324 20 10 57 17 99 17 l67 1 3 94 c2 56 -1 95 -7 96 -33 10 -64 12 -90 5z"
            />
            <path
                d="M4310 3420 c-112 -14 -209 -74 -246 -154 -40 -86 -40 -86 79 -86
l103 0 9 33 c22 72 147 89 200 26 19 -23 25 -42 25 -78 l0 -48 -106 -7 c-239
-16 -346 -96 -347 -256 0 -138 104 -232 257 -232 78 0 124 15 173 56 34 29 37
27 48 -21 l7 -33 104 0 c105 0 105 0 98 23 -20 62 -24 110 -24 318 0 274 -8
310 -80 380 -69 68 -172 95 -300 79z m170 -509 l0 -80 -36 -27 c-27 -21 -50
-29 -93 -32 -50 -4 -61 -1 -89 23 -43 36 -45 98 -6 144 31 37 68 49 157 50
l67 1 0 -79z"
            />
            <path
                d="M5195 3420 c-44 -10 -69 -25 -103 -65 -17 -19 -34 -35 -37 -35 -3 0
    -5 20 -5 45 l0 45 -95 0 -95 0 0 -395 0 -395 100 0 100 0 0 263 c0 289 0 291
63 324 20 10 57 17 99 17 l67 1 3 94 c2 56 -1 95 -7 96 -33 10 -64 12 -90 5z"
            />
            <path
                d="M7660 3420 c-112 -14 -209 -74 -246 -154 -40 -86 -40 -86 79 -86
l103 0 9 33 c22 72 147 89 200 26 19 -23 25 -42 25 -78 l0 -48 -106 -7 c-239
-16 -346 -96 -347 -256 0 -138 104 -232 257 -232 78 0 124 15 173 56 34 29 37
27 48 -21 l7 -33 104 0 c105 0 105 0 98 23 -20 62 -24 110 -24 318 0 274 -8
310 -80 380 -69 68 -172 95 -300 79z m170 -509 l0 -80 -36 -27 c-27 -21 -50
-29 -93 -32 -50 -4 -61 -1 -89 23 -43 36 -45 98 -6 144 31 37 68 49 157 50
l67 1 0 -79z"
            />
            <path
                d="M8579 3420 c-54 -9 -116 -39 -143 -69 -28 -30 -36 -26 -36 19 l0 40
    -95 0 -95 0 0 -395 0 -395 100 0 100 0 0 283 c0 309 0 311 60 342 16 8 51 15
78 15 61 0 97 -25 112 -78 5 -21 10 -150 10 -299 l0 -263 100 0 100 0 0 280 0
280 33 36 c28 31 41 37 85 42 29 2 64 -1 80 -7 55 -23 57 -31 60 -343 l3 -288
100 0 100 0 -3 318 c-3 311 -3 318 -27 365 -41 84 -105 119 -217 119 -84 0
-150 -25 -205 -78 l-36 -35 -28 37 c-46 60 -140 90 -236 74z"
            />
            <path
                d="M10719 3420 c-55 -9 -97 -30 -143 -71 l-35 -30 -6 46 -7 45 -94 0
    -94 0 0 -395 0 -395 100 0 100 0 0 279 c0 267 1 279 21 305 11 14 34 33 49 41
35 18 109 19 145 3 52 -23 55 -43 55 -348 l0 -280 105 0 105 0 0 263 c0 275
-9 365 -39 426 -46 89 -143 130 -262 111z"
            />
            <path d="M5420 3015 l0 -395 100 0 100 0 0 395 0 395 -100 0 -100 0 0 -395z" />
            <path
                d="M6639 3328 c134 -229 171 -296 171 -306 0 -5 -30 -61 -66 -124 -37
    -62 -89 -150 -115 -195 l-49 -83 110 0 109 0 60 108 c93 166 76 163 158 21
l70 -124 107 -3 c58 -1 106 0 106 3 0 4 -50 93 -112 198 -61 105 -111 196
-111 202 0 5 46 88 102 183 56 95 104 179 107 187 5 13 -11 15 -99 15 l-106 0
-68 -120 c-37 -66 -70 -117 -74 -112 -4 4 -35 58 -69 120 l-62 112 -109 0
-109 0 49 -82z"
            />
            <path d="M9960 3015 l0 -395 100 0 100 0 0 395 0 395 -100 0 -100 0 0 -395z" />
            <path
                d="M9570 2813 c-39 -27 -49 -45 -50 -89 -1 -133 201 -148 226 -17 7 39
    -19 92 -57 110 -34 18 -90 16 -119 -4z"
            />
        </g>
    </svg>
)

export const Like = ({ width = '20px', height = '21px', fill = '#03a9f4' }) => (
    <svg
        version="1.1"
        id="Capa_1"
        width={width}
        height={height}
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 456.814 456.814"
    >
        <g>
            <g>
                <path
                    d="M441.11,252.677c10.468-11.99,15.704-26.169,15.704-42.54c0-14.846-5.432-27.692-16.259-38.547
			c-10.849-10.854-23.695-16.278-38.541-16.278h-79.082c0.76-2.664,1.522-4.948,2.282-6.851c0.753-1.903,1.811-3.999,3.138-6.283
			c1.328-2.285,2.283-3.999,2.852-5.139c3.425-6.468,6.047-11.801,7.857-15.985c1.807-4.192,3.606-9.9,5.42-17.133
			c1.811-7.229,2.711-14.465,2.711-21.698c0-4.566-0.055-8.281-0.145-11.134c-0.089-2.855-0.574-7.139-1.423-12.85
			c-0.862-5.708-2.006-10.467-3.43-14.272c-1.43-3.806-3.716-8.092-6.851-12.847c-3.142-4.764-6.947-8.613-11.424-11.565
			c-4.476-2.95-10.184-5.424-17.131-7.421c-6.954-1.999-14.801-2.998-23.562-2.998c-4.948,0-9.227,1.809-12.847,5.426
			c-3.806,3.806-7.047,8.564-9.709,14.272c-2.666,5.711-4.523,10.66-5.571,14.849c-1.047,4.187-2.238,9.994-3.565,17.415
			c-1.719,7.998-2.998,13.752-3.86,17.273c-0.855,3.521-2.525,8.136-4.997,13.845c-2.477,5.713-5.424,10.278-8.851,13.706
			c-6.28,6.28-15.891,17.701-28.837,34.259c-9.329,12.18-18.94,23.695-28.837,34.545c-9.899,10.852-17.131,16.466-21.698,16.847
			c-4.755,0.38-8.848,2.331-12.275,5.854c-3.427,3.521-5.14,7.662-5.14,12.419v183.01c0,4.949,1.807,9.182,5.424,12.703
			c3.615,3.525,7.898,5.38,12.847,5.571c6.661,0.191,21.698,4.374,45.111,12.566c14.654,4.941,26.12,8.706,34.4,11.272
			c8.278,2.566,19.849,5.328,34.684,8.282c14.849,2.949,28.551,4.428,41.11,4.428h4.855h21.7h10.276
			c25.321-0.38,44.061-7.806,56.247-22.268c11.036-13.135,15.697-30.361,13.99-51.679c7.422-7.042,12.565-15.984,15.416-26.836
			c3.231-11.604,3.231-22.74,0-33.397c8.754-11.611,12.847-24.649,12.272-39.115C445.395,268.286,443.971,261.055,441.11,252.677z"
                />
                <path
                    d="M100.5,191.864H18.276c-4.952,0-9.235,1.809-12.851,5.426C1.809,200.905,0,205.188,0,210.137v182.732
			c0,4.942,1.809,9.227,5.426,12.847c3.619,3.611,7.902,5.421,12.851,5.421H100.5c4.948,0,9.229-1.81,12.847-5.421
			c3.616-3.62,5.424-7.904,5.424-12.847V210.137c0-4.949-1.809-9.231-5.424-12.847C109.73,193.672,105.449,191.864,100.5,191.864z
			 M67.665,369.308c-3.616,3.521-7.898,5.281-12.847,5.281c-5.14,0-9.471-1.76-12.99-5.281c-3.521-3.521-5.281-7.85-5.281-12.99
			c0-4.948,1.759-9.232,5.281-12.847c3.52-3.617,7.85-5.428,12.99-5.428c4.949,0,9.231,1.811,12.847,5.428
			c3.617,3.614,5.426,7.898,5.426,12.847C73.091,361.458,71.286,365.786,67.665,369.308z"
                />
            </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
)
